import React from 'react';
import { Form, Select } from 'antd';
import { FormInstance } from 'antd/es/form';
import FormSection from '../FormSection';
import CurvDown from '../svg/CurvDown';

const { Option } = Select;

interface TerminationProps {
  form: FormInstance;
}

const Termination: React.FC<TerminationProps> = ({ form }) => {
  const yesNoOptions = ['Yes', 'No'];

  return (
    <div className="flex flex-col w-full h-full termination-container mb-[31px] md:mb-0 ">
      <style>
        {`
          .termination-container .ant-form-item-label {
            min-height: 58px !important;
            margin-bottom: 8px !important;
            display: flex !important;
            align-items: flex-end !important;
          }
          @media (max-width: 767px) {
            .termination-container .ant-form-item-label {
              min-height: unset !important;
              margin-bottom: 0px !important;
              display: block !important;
            }
          }
          .termination-container .ant-select-selector {
            padding-left: 19px !important;
            padding-right: 19px !important;
          }
        `}
      </style>
      <FormSection title="Termination" columns={1}>
        <div className="flex flex-col gap-0 w-full">
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-[60px] gap-y-[28px] md:gap-y-[37px] w-full">
            <Form.Item
              label="Were you qualified for the job?"
              name={['termination_info', 'were_qualified']}
              className="mb-0"
            >
              <Select placeholder="Select" suffixIcon={<CurvDown className="pt-[10px] md:pt-[14px]" />}>
                {yesNoOptions.map(option => (
                  <Option key={option} value={option}>{option}</Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="Did you satisfy the requirements of the job?"
              name={['termination_info', 'satisfied_requirements']}
              className="mb-0"
            >
              <Select placeholder="Select" suffixIcon={<CurvDown className="pt-[10px] md:pt-[14px]" />}>
                {yesNoOptions.map(option => (
                  <Option key={option} value={option}>{option}</Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="Were you replaced?"
              name={['termination_info', 'were_replaced']}
              className="mb-0"
            >
              <Select placeholder="Select" suffixIcon={<CurvDown className="pt-[10px] md:pt-[14px]" />}>
                {yesNoOptions.map(option => (
                  <Option key={option} value={option}>{option}</Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="Was the person who replaced you the same basis?"
              name={['termination_info', 'replacement_same_basis']}
              className="mb-0"
            >
              <Select placeholder="Select" suffixIcon={<CurvDown className="pt-[10px] md:pt-[14px]" />}>
                {yesNoOptions.map(option => (
                  <Option key={option} value={option}>{option}</Option>
                ))}
              </Select>
            </Form.Item>
          </div>
        </div>
      </FormSection>
    </div>
  );
};

export default Termination;
